export default __webpack_public_path__ + "static/media/skype.8c041d05.svg";